export default __webpack_public_path__ + "static/white-logo-7ddbbcc1e89b86361b4a11349434a5fe.svg";